import styled from '@emotion/styled'

export const InvoiceEditorPreviewToggleWrapper = styled.div`
  width: 100%;
`
